import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=4013ce7a&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"
import style0 from "./Fields.vue?vue&type=style&index=0&id=4013ce7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013ce7a",
  null
  
)

export default component.exports